import React from "react";

const RecurringModal = ({ isOpen, onContinue, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
        <h2 className="text-xl font-semibold mb-2">Recurring Payment Notice</h2>
        <p className="text-sm text-gray-600 mb-4">
          This payment will be charged automatically every billing cycle.
        </p>

        <button
          onClick={onContinue}
          className="bg-blue-600 text-white font-medium py-2 w-full rounded-md mb-3"
        >
          Continue
        </button>

        <button
          onClick={onClose}
          className="bg-gray-300 text-black font-medium py-2 w-full rounded-md"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default RecurringModal;
